import React from 'react';
import { compose, defaultProps, setDisplayName, withProps, withState, withHandlers } from 'recompose';
import View from '@bubble-ui/primitive-view';
import omitProps from '@hocs/omit-props';
import elementRectObserver from 'element-rect-observer';

var Layout = function Layout(props) {
  return /*#__PURE__*/React.createElement(View, props);
};

export default compose(setDisplayName('Layout'), defaultProps({
  width: 0,
  height: 0,
  debounceOnRequestAnimationFrame: false
}), withState('dimensions', 'setDimensions', function (_ref) {
  var width = _ref.width,
      height = _ref.height;
  return {
    width: width,
    height: height,
    x: 0,
    y: 0
  };
}), withHandlers(function () {
  var stopObserving = null;
  return {
    onRef: function onRef(_ref2) {
      var debounceOnRequestAnimationFrame = _ref2.debounceOnRequestAnimationFrame,
          setDimensions = _ref2.setDimensions,
          _onRef = _ref2.onRef,
          onResize = _ref2.onResize;
      return function (domElement) {
        if (domElement != null) {
          stopObserving = elementRectObserver(domElement, function (_ref3) {
            var width = _ref3.width,
                height = _ref3.height,
                x = _ref3.x,
                y = _ref3.y;
            var dimensions = {
              width: width,
              height: height,
              x: x,
              y: y
            };

            if (typeof onResize === 'function') {
              onResize(dimensions);
            } else {
              setDimensions(dimensions);
            }
          }, debounceOnRequestAnimationFrame);
        } else if (stopObserving) {
          stopObserving();
        }

        if (typeof _onRef === 'function') {
          _onRef(domElement);
        }
      };
    }
  };
}), withProps(function (_ref4) {
  var children = _ref4.children,
      dimensions = _ref4.dimensions;
  return {
    children: typeof children === 'function' ? children(dimensions) : children
  };
}), omitProps('debounceOnRequestAnimationFrame', 'setDimensions', 'width', 'height', 'onResize', 'dimensions'))(Layout);
//# sourceMappingURL=Layout.js.map